import { setWindowLocation, openInNewTab } from 'js-utils/http';
import { constants as destinationConstants } from '@eb/destination-utils';

const { EVENTBRITE } = destinationConstants;

export const openEventUrl = (url, ticketsBy = EVENTBRITE) => {
    if (ticketsBy === EVENTBRITE) {
        setWindowLocation(url);
    } else {
        openInNewTab(url);
    }
};
